import React, { useState, useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { FaEnvelope, FaTimes } from "react-icons/fa";
import "./PlanaDocente.css";

//  Importa foto de perfil
import defaultPhoto from "../assets/nosotros/plana_docente/perfil.jpg";
import azahuanche from "../assets/nosotros/plana_docente/azahuanche.jpg";
import medina from "../assets/nosotros/plana_docente/medina.jpg";
import zuñiga from "../assets/nosotros/plana_docente/zuñiga.jpg";
import luque from "../assets/nosotros/plana_docente/luque.jpg";
import apari from "../assets/nosotros/plana_docente/apari.jpg";
import karina from "../assets/nosotros/plana_docente/karina.jpg";
import gutierrez from "../assets/nosotros/plana_docente/gutierrez.jpg";
import huanasca from "../assets/nosotros/plana_docente/huanasca.jpg";
import huanca from "../assets/nosotros/plana_docente/huanca.jpg";
import monares from "../assets/nosotros/plana_docente/monares.jpg";
import padilla from "../assets/nosotros/plana_docente/padilla.jpg";
import ferro from "../assets/nosotros/plana_docente/ferro.jpg";
import huailla from "../assets/nosotros/plana_docente/huailla.jpg";
import meza from "../assets/nosotros/plana_docente/meza.jpg";
import baca from "../assets/nosotros/plana_docente/baca.jpg";
import negron from "../assets/nosotros/plana_docente/negron.jpg";
import ramirez from "../assets/nosotros/plana_docente/ramirez.jpg";
import razo from "../assets/nosotros/plana_docente/razo.jpg";
import huaracha from "../assets/nosotros/plana_docente/huaracha.jpg";
import quihui from "../assets/nosotros/plana_docente/quihui.jpg";
import cabrera from "../assets/nosotros/plana_docente/cabrera.jpg";
import palomares from "../assets/nosotros/plana_docente/palomares.jpg";
import pillaca from "../assets/nosotros/plana_docente/pillaca.jpg";
import rojas from "../assets/nosotros/plana_docente/rojas.jpg";
import barzola from "../assets/nosotros/plana_docente/barzola.jpg";


//  Importa los CV en PDF
import AZAHUANCHE from "../assets/nosotros/plana_docente/AZAHUANCHE.pdf";
import MEDINA from "../assets/nosotros/plana_docente/MEDINA.pdf";
import ZUÑIGA from "../assets/nosotros/plana_docente/ZUÑIGA.pdf";
import LUQUE from "../assets/nosotros/plana_docente/LUQUE.pdf";
import APARI from "../assets/nosotros/plana_docente/APARI.pdf";
import KARINA from "../assets/nosotros/plana_docente/KARINA.pdf";
import GUTIERREZ from "../assets/nosotros/plana_docente/GUTIERREZ.pdf";
import HUANASCA from "../assets/nosotros/plana_docente/HUANASCA.pdf";
import HUANCA from "../assets/nosotros/plana_docente/HUANCA.pdf";
import MONARES from "../assets/nosotros/plana_docente/MONARES.pdf";
import PADILLA from "../assets/nosotros/plana_docente/PADILLA.pdf";
import FERRO from "../assets/nosotros/plana_docente/FERRO.pdf";
import HUAILLA from "../assets/nosotros/plana_docente/HUAILLA.pdf";
import MEZA from "../assets/nosotros/plana_docente/MEZA.pdf";
import BACA from "../assets/nosotros/plana_docente/BACA.pdf";
import NEGRON from "../assets/nosotros/plana_docente/NEGRON.pdf";
import RAMIREZ from "../assets/nosotros/plana_docente/RAMIREZ.pdf";
import RAZO from "../assets/nosotros/plana_docente/RAZO.pdf";
import HUARACHA from "../assets/nosotros/plana_docente/HUARACHA.pdf";
import QUIHUI from "../assets/nosotros/plana_docente/QUIHUI.pdf";
import CABRERA from "../assets/nosotros/plana_docente/CABRERA.pdf";
import PALOMARES from "../assets/nosotros/plana_docente/PALOMARES.pdf";
import PILLACA from "../assets/nosotros/plana_docente/pillaca.pdf";
import ROJAS from "../assets/nosotros/plana_docente/ROJAS.pdf";
import BARZOLA from "../assets/nosotros/plana_docente/BARZOLA.pdf";
import Bastidas from "../assets/nosotros/plana_docente/Bastidas.pdf";


const docentesData = {
  "Construcción Civil": [
    { nombre: "ANTONIO PAZ SOLDAN AMADEO SIXTO", correo: "antonio.amadeo@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "AZAHUANCHE ASMAT VIRGINIA LIBERTAD", correo: "azahuanche.virginia@iestpgildaballivian.edu.pe", foto: azahuanche , pdf:AZAHUANCHE},
    { nombre: "BASTIDAS PINO DIONI AMADOR", correo: "bastidas.dioni@iestpgildaballivian.edu.pe", foto: defaultPhoto, pdf:Bastidas },
    { nombre: "GALLARDO MENDOZA JUAN CARLOS", correo: "gallardo.juan@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "HUARHUA CONTRERAS ESTAQUIO", correo: "huarhua.eustaquio@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "MEDINA OCHOA JOSE GONZALO", correo: "medina.jose@iestpgildaballivian.edu.pe", foto: medina, pdf:MEDINA },
    { nombre: "ZUÑIGA RONDINEL LEO", correo: "zuniga.leo@iestpgildaballivian.edu.pe", foto: zuñiga, pdf: ZUÑIGA},
  ],

  "Contabilidad": [
    { nombre: "BEYZAGA FIGUEROA CONSTANZA VIRGINIA", correo: "beyzaga.constanza@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "CHIPANA TAGLE DENNIS DANIEL", correo: "chipana.dennis@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "FERNANDEZ CASTRO JORGE MARCELINO", correo: "fernandez.jorge@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "HERNANDEZ BECERRA GUILLERMO", correo: "hernandez.guillermo@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "LUQUE SERRANO VIRGINIA", correo: "luque.virginia@iestpgildaballivian.edu.pe", foto: luque, pdf: LUQUE },
    { nombre: "MORENO MANCO ALFONSO CESAR", correo: "moreno.alfonso@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "OLIVARES MANDUJANO MARICELA FRESIALEO", correo: "olivares.maricela@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "OSCCO PAREDES JAIME GREGORIO", correo: "oscco.jaime@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "RUIZ DE CASTILLA DONGO MARIA DEL ROSARIO", correo: "ruizdecastilla.maria@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "ZEGARRA BARRIENTOS LIZ MARIBEL", correo: "zegarra.liz@iestpgildaballivian.edu.pe", foto: defaultPhoto },
  ],

  "Desarrollo de Sistemas": [
    { nombre: "APARI VALENZUELA OSCAR", correo: "apari.oscar@iestpgildaballivian.edu.pe", foto: apari, pdf: APARI },
    { nombre: "BRUNO LUCIANI ISMAEL JOSSELY", correo: "bruno.ismael@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "CARRASCO LINARES LIZARDO ALEJANDRO", correo: "carrasco.alejandro@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "ESTRADA YNDIGOYEN EDUARDO LEON", correo: "estrada.eduardo@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "GALVEZ NIÑO DE GUZMAN KARINA", correo: "galvez.karina@iestpgildaballivian.edu.pe", foto: karina, pdf:KARINA },
    { nombre: "GUTIERREZ BARAHONA JOSE DIOMEDES", correo: "gutierrez.jose@iestpgildaballivian.edu.pe", foto: gutierrez, pdf: GUTIERREZ },
    { nombre: "HUANASCA RIVAS DAVID CORNELIO", correo: "huanasca.david@iestpgildaballivian.edu.pe", foto: huanasca, pdf: HUANASCA },
    { nombre: "HUANCA PACHAURI BENJAMIN", correo: "huanca.benjamin@iestpgildaballivian.edu.pe", foto: huanca, pdf: HUANCA },
    { nombre: "MONARES CHAVEZ MAURA BEATRIZ", correo: "monares.maura@iestpgildaballivian.edu.pe", foto: monares, pdf: MONARES },
    { nombre: "PADILLA OBREGON CESAR EDMUNDO", correo: "padilla.cesar@iestpgildaballivian.edu.pe", foto: padilla, pdf: PADILLA },
    { nombre: "PORTAL BAZAN PEDRO DE LOS ANGELES", correo: "portal.carlos@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "YAYA GOMEZ MARÍA EMILIA", correo: "yaya.maria@iestpgildaballivian.edu.pe", foto: defaultPhoto },
  ],

  "Electricidad Industrial": [
    { nombre: "CARHUANCHO PALOMINO LUIS ENRIQUE", correo: "carhuancho.luis@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "FELIPE GUILLEN LUIS MIGUEL", correo: "felipe.luis@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "GARCIA TERAN PEDRO VEDA", correo: "garcia.pedro@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "GUERRA CABALLERO CARLOS RAUL", correo: "guerra.carlosc@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "HERRERA TRELLES JULIO CESAR", correo: "herrera.julio@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "MELENDEZ GALINDO LAUREANO", correo: "melendez.laureano@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "MERA ANDIA JOSE LUIS", correo: "mera.jose@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "PUJAY ACEVEDO JOEL ELISEO", correo: "pujay.joel@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "ROJAS PURIS JORGE GABRIEL", correo: "rojas.jorge@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "TALLA CONDESO ROBERTO EDGARDO", correo: "talla.roberto@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "VILLAVICENCIO RIVEROS EDWIN RICHARD", correo: "villavicencio.edwin@iestpgildaballivian.edu.pe", foto: defaultPhoto },
  ],

  "Electrónica Industrial": [
    { nombre: "FABIAN BRAVO JOEL ENRIQUE", correo: "fabian.joel@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "FERRO QUICAÑO JOSE LUIS", correo: "ferro.jose@iestpgildaballivian.edu.pe", foto: ferro, pdf: FERRO },
    { nombre: "GALLARDO LOPEZ ALEX NOE", correo: "gallardo.alex@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "GUILLEN ROJAS ALFREDO", correo: "guillen.alfredo@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "HUAILLA ATAO DELIA CONCEPCIÓN", correo: "huailla.delia@iestpgildaballivian.edu.pe", foto: huailla, pdf: HUAILLA },
    { nombre: "INGA PEÑA AULO WILFREDO", correo: "inga.aulo@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "MEZA RODRIGUEZ FELIX CELSO", correo: "meza.felix@iestpgildaballivian.edu.pe", foto: meza, pdf: MEZA},
    { nombre: "NOLASCO SANDOVAL LUIS ALFREDO", correo: "nolasco.luis@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "RAMOS ROJAS ARTURO", correo: "ramos.arturo@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "ROJAS CAHUA LUIS ALBERTO", correo: "rojas.luis@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "UNSIHUAY TOVAR ROBERTO FLORENTINO", correo: "unsihuay.roberto@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "VELASQUEZ CABANILLAS HECTOR FELIPE", correo: "velasquez.hector@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "VILLAVICENCIO JIMENEZ SERGIO CARLOS ANDRES", correo: "villavicencio.sergio@iestpgildaballivian.edu.pe", foto: defaultPhoto },
  ],

  "Gestión Administrativa": [
    { nombre: "BACA TELLO CARLOS ARTURO", correo: "baca.carlos@iestpgildaballivian.edu.pe", foto: baca, pdf:BACA },
    { nombre: "BECERRA BRINGAS MIGUEL ANGEL", correo: "becerra.miguel@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "LUCAS TAMAYO SIDNEY ERICO", correo: "lucas.sidney@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "LUYO VENEGAS RUTH", correo: "luyo.ruth@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "MIRANDA GONZALES NEL MARTIN", correo: "miranda.nel@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "NEGRON ALVARADO ELMER AUGURIO", correo: "negron.elmer@iestpgildaballivian.edu.pe", foto: negron, pdf:NEGRON},
    { nombre: "QUISPE DIAZ DOMENICA AGRIPINA", correo: "quispe.domenica@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "RAMIREZ CHUQUIHUANGA LUIS ALBERTO", correo: "ramirez.luis@iestpgildaballivian.edu.pe", foto: ramirez, pdf: RAMIREZ },
    { nombre: "RAZO QUISPE JOSE LUIS", correo: "razo.jose@iestpgildaballivian.edu.pe", foto: razo, pdf: RAZO},
    { nombre: "VILCHEZ MEDINA WALTER ARMANDO", correo: "vilchez.walter@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "YNGUIL FERNANDEZ WILLIAN MARTIN", correo: "ynguil.william@iestpgildaballivian.edu.pe", foto: defaultPhoto },
  ],

  "Mecánica de Producción Industrial": [
    { nombre: "CALDERON CORNELIO WILMER WASHINGTON", correo: "calderon.wilmer@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "COLOS TENORIO RODUEN", correo: "colos.roduen@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "GUTIERREZ TORRES CESAR EDISON", correo: "gutierrez.cesar@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "HUARACHA CASAS RIGOBERTO PERCY", correo: "huaracha.rigoberto@iestpgildaballivian.edu.pe", foto: huaracha, pdf: HUARACHA },
    { nombre: "JURADO GUILLEN NOSSER MARIANO", correo: "jurado.nosser@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "MAMANI SANTA CRUZ ANA YOVANA", correo: "mamani.ana@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "QUIHUI YNGA FRANCISCO", correo: "quihui.francisco@iestpgildaballivian.edu.pe", foto: quihui, pdf: QUIHUI },
    { nombre: "QUISPE FLORES NEIL", correo: "quispe.neil@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "SORIA PEREZ EMILIA", correo: "soria.emilia@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "SOSA MASGO MOISES EULOGIO", correo: "sosa.moises@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "VICENCIO RAMOS EFRAIN", correo: "vicencio.efrain@iestpgildaballivian.edu.pe", foto: defaultPhoto },
  ],

  "Mecatrónica Automotriz": [
    { nombre: "CABRERA NUÑEZ JORDAN FELIPE", correo: "cabrera.jordan@iestpgildaballivian.edu.pe", foto: cabrera, pdf: CABRERA },
    { nombre: "GASPAR PRADO JUAN WILLIAM", correo: "gaspar.juan@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "PALOMARES ANSELMO JIM ANDREW", correo: "palomares.jim@iestpgildaballivian.edu.pe", foto: palomares, pdf: PALOMARES },
    { nombre: "PALOMINO RIOS DAVID ANGEL", correo: "palomino.david@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "PILLACA DIAZ TEODORO", correo: "pillaca.teodoro@iestpgildaballivian.edu.pe", foto: pillaca, pdf: PILLACA },
    { nombre: "ROJAS SALDAÑA ALFREDO MANUEL", correo: "rojas.alfredo@iestpgildaballivian.edu.pe", foto: rojas, pdf: ROJAS },
    { nombre: "VILCHEZ CORDOVA VICENTE HEMERGILDO", correo: "vilchez.vicente@iestpgildaballivian.edu.pe", foto: defaultPhoto },
  ],

  "Docentes de Empleabilidad": [
    { nombre: "BARZOLA QUICAÑO DORIS NANCY", correo: "barzola.doris@iestpgildaballivian.edu.pe", foto: barzola, pdf: BARZOLA },
    { nombre: "CAMARGO CAMERO JAVIER", correo: "camargo.javier@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "ESPIRITU GUERREROS JULIAN TEODORO", correo: "espiritu.julian@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "EYZAGUIRRE ESPINO JULIO CESAR", correo: "eyzaguirre.julio@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "FELIX VASQUEZ PAOLA LISSET", correo: "felix.paola@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "GARCIA CABRERA JUAN", correo: "garcia.juan@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "LAGOS BAUTISTA GABY LUZ", correo: "lagos.gaby@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "PAREJA PINTO FEDERICO ANTONIO", correo: "pareja.federico@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "PEREZ MENDOZA LILA JESSICA", correo: "perez.lila@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "PONCE TEJADA MARÍA DEL PILAR", correo: "ponce.maria@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "RISCO PAICO WILFREDO", correo: "risco.wilfredo@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "ROSAS RETUERTO GOMEZ VLADIMIR HERNANI", correo: "rosasretuerto.vladimir@iestpgildaballivian.edu.pe", foto: defaultPhoto },
    { nombre: "SOLANO ZAPATA ELIZABETH DIANA", correo: "solano.elizabeth@iestpgildaballivian.edu.pe", foto: defaultPhoto },
  ],
};


const PlanaDocente = () => {
  const [selectedPdf, setSelectedPdf] = useState(null);

  useEffect(() => {
    AOS.init({ duration: 800 });
  }, []);

  const handleOpenPdf = (pdf) => {
    setSelectedPdf(pdf);
    
  };

  const handleClosePdf = () => {
    setSelectedPdf(null);
  };

  return (
    <section className="plana-docente-page">
      {/* Banner superior */}
      <div className="banner-docente">
        <div className="overlay"></div>
        <div className="text-center text-white">
          <h1 className="fw-bold">Plana Docente</h1>
          <p className="lead">
            Profesionales comprometidos con la excelencia educativa y tecnológica.
          </p>
        </div>
      </div>

      {/*  Contenido principal */}
      <div className="container py-5">
        {Object.keys(docentesData).map((programa, idx) => (
          <div key={idx} className="mb-5" data-aos="fade-up">
            <h2 className="programa-title">{programa}</h2>
            <div className="row g-4">
              {docentesData[programa].map((docente, i) => (
                <div className="col-6 col-md-4 col-lg-3" key={i} >
                  <div className="card-docente text-center">
                   <div className="foto-container">
                      {docente.pdf ? (
                        <img
                          src={docente.foto || defaultPhoto}
                          alt={docente.nombre}
                          className="foto-docente"
                          onClick={() => handleOpenPdf(docente.pdf)}
                          style={{ cursor: "pointer" }}
                        />
                      ) : (
                        <div className="falta-cv">
                          <img
                            src={docente.foto || defaultPhoto}
                            alt={docente.nombre}
                            className="foto-docente opacity-50"
                          />
                          <p className="text-danger fw-bold mt-2">Falta cargar CV</p>
                        </div>
                      )}
                    </div>

                    <div className="docente-info">
                      <h5>{docente.nombre}</h5>
                      <p className="correo">
                        <FaEnvelope className="me-2" />
                        {docente.correo}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      {/*  Modal PDF */}
      {selectedPdf && (
        <div className="pdf-modal" onClick={handleClosePdf}>
          <div
            className="pdf-modal-content-wide"
            onClick={(e) => e.stopPropagation()}
          >
            <button className="close-btn" onClick={handleClosePdf}>
              <FaTimes size={20} />
            </button>
            <iframe
              src={`${selectedPdf}#view=FitH`}
              title="CV Docente"
              className="pdf-full-view-wide"
            ></iframe>
          </div>
        </div>
      )}
    </section>
  );
};

export default PlanaDocente;

